import React, { Component } from "react"
import { Link } from "react-router-dom"

export default class Logo extends Component {
  render() {
    return (
      <div className="logo">
        <Link to="/" className="simple-text">
          {this.props.siteName}
        </Link>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Logo.js